import React, { createContext, useContext } from 'react';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import { useAuth } from '../../context/AuthContext';

/** Quand true, les pages catalogue n’affichent pas une deuxième sidebar (onglets Paramètres véhicules). */
export const AdminPageEmbedContext = createContext(false);

/**
 * Layout pour les pages dashboard avec sidebar et navbar
 * Optimisé pour que la navbar prenne toute la largeur et qu'il n'y ait pas d'espaces vides
 */
const DashboardLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const embedded = useContext(AdminPageEmbedContext);

  if (embedded) {
    return <>{children}</>;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Navbar - Fixée en haut avec largeur 100%, z-index élevé */}
      <div className="fixed top-0 left-0 right-0 z-50 w-full">
        <Navbar isLoggedIn={!!user} user={user} onLogout={logout} />
      </div>
      
      {/* Conteneur principal avec padding-top pour compenser la navbar fixe (64px = 16rem = h-16) */}
      <div style={{ paddingTop: '64px', minHeight: '100vh', margin: 0, paddingLeft: 0, paddingRight: 0, paddingBottom: 0 }}>
        {/* Sidebar - Fixée dans son propre composant (256px de largeur = w-64) */}
        <Sidebar />
        
        {/* Main Content - Commence exactement à 256px de la gauche (largeur de la sidebar) */}
        <main 
          style={{ 
            marginLeft: '256px',
            width: 'calc(100% - 256px)',
            minHeight: 'calc(100vh - 64px)',
            padding: 0,
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0
          }}
        >
          {/* Conteneur interne avec padding sauf à gauche pour coller à la sidebar */}
          <div style={{ paddingTop: '24px', paddingRight: '24px', paddingBottom: '24px', paddingLeft: '0', width: '100%', maxWidth: 'none', margin: 0, boxSizing: 'border-box' }}>
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;

